import { render, staticRenderFns } from "./usermodul.vue?vue&type=template&id=2843246c&scoped=true"
import script from "./usermodul.vue?vue&type=script&lang=js"
export * from "./usermodul.vue?vue&type=script&lang=js"
import style0 from "./usermodul.vue?vue&type=style&index=0&id=2843246c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2843246c",
  null
  
)

export default component.exports